import { render, staticRenderFns } from "./SnakeSpinner.vue?vue&type=template&id=28167b12&scoped=true"
import script from "./SnakeSpinner.vue?vue&type=script&lang=js"
export * from "./SnakeSpinner.vue?vue&type=script&lang=js"
import style0 from "./SnakeSpinner.vue?vue&type=style&index=0&id=28167b12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28167b12",
  null
  
)

export default component.exports